"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POIRequired = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const providers_1 = require("../railgun/core/providers");
const engine_1 = require("@railgun-community/engine");
class POIRequired {
    static requiredForNetwork = {};
    static async isRequiredForNetwork(networkName) {
        if ((0, shared_models_1.isDefined)(this.requiredForNetwork[networkName])) {
            return this.requiredForNetwork[networkName];
        }
        const { poi } = shared_models_1.NETWORK_CONFIG[networkName];
        if (!(0, shared_models_1.isDefined)(poi)) {
            return false;
        }
        const provider = (0, providers_1.getFallbackProviderForNetwork)(networkName);
        const blockNumber = await provider.getBlockNumber();
        const isRequired = poi.launchBlock < blockNumber;
        if (isRequired) {
            this.requiredForNetwork[networkName] = true;
        }
        if (blockNumber + 10000 < poi.launchBlock) {
            // Launches in at least 10k blocks.
            this.requiredForNetwork[networkName] = false;
        }
        return isRequired;
    }
    static async getRequiredListKeys(networkName) {
        if (!(await this.isRequiredForNetwork(networkName))) {
            return [];
        }
        return engine_1.POI.getActiveListKeys();
    }
}
exports.POIRequired = POIRequired;
